$(document).ready(function() {
  function updateArrowsTop() {
    $('.jdgm-carousel-wrapper').each(function() {
      var $wrapper = $(this);
      var $title = $wrapper.find('.jdgm-carousel-title');
      var $arrows = $wrapper.find('.jdgm-carousel__arrows');

      if ($title.length && $arrows.length) {
        var titleHeight = $title.outerHeight();
        var arrowsHeight = $arrows.outerHeight();

        var top = titleHeight - arrowsHeight - 10;

        $arrows.css('top', top + 'px');
      }
    });
  }

  updateArrowsTop();

  $(window).on('resize scroll', updateArrowsTop);
});

$(document).ready(function() {
  var target = document.querySelector(".jdgm-carousel-title");
  if (!target) return;

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function() {
      if ($(target).text().trim() !== "COMMENT") {
        $(target).text("COMMENT");
      }
    });
  });

  observer.observe(target, {
    childList: true,
    characterData: true,
    subtree: true
  });

  if ($(target).text().trim() !== "COMMENT") {
    $(target).text("COMMENT");
  }
});
